// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    ddg_enabled: true,
    env: 'dev',
    production: false,
    API: 'https://api-app.dev.xref.com/v1/',
    AUTH_API: 'https://auth.dev.xref.com/',
    AUTH_API_OMNI: 'https://auth.dev.xref.io/',
    DOMAIN: 'xref.com',
    OAUTH_CHECKR_REDIRECT: 'https://employer.dev.xref.com/integrations',
    LINKED_IN_API: 'https://api-linkedin.dev.xref.com/',
    APP_URL: 'https://employer.dev.xref.com/',
    ID_API_OMNI: 'https://id.dev.xref.io/',
    ADMIN_URL: 'https://admin.dev.xref.com/',
    OMNI_URL: 'https://app.dev.xref.com/',
    TRUST_URL: 'https://console.dev.trustmarketplace.com/',
    SIGNUP_URL: 'https://signup.dev.xref.com/',
    RETURN_URL_WHITELIST: [
        'https://login.dev.xref.com/',
        'https://employer.dev.xref.com/',
        'https://admin.dev.xref.com/',
        'https://help.dev.xref.com/',
        'https://search.dev.xref.com/'
    ],
    QUESTIONNAIRE_OAUTH_RET_URL: 'https://template-builder.dev.xref.com/oauth/connect',
    QUESTIONNAIRE_OAUTH_CLIENT_ID: '6I5efx1HpHs4ym6Ii8DSUr58he8Q22M1iBDJPIHZ',
    LOGIN_APP_URL: 'https://login.dev.xref.com/',
    i18nBaseUrl: 'https://login.dev.xref.com/i18n'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
